export default {
    USERNAME_PASSWORD: 0,
    BIOMETRIC: 1,
}